'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes');

var GRAPHS = config.graphs;

var chartId = 'CUSTOMER_BY_DEVICE_COUNT',
    dataSeries = {
        DEVICE_COUNT: 'deviceCount'
    },
    fieldNames = {
        DEVICE_COUNT: 'amcCurrentNumOfManagedDevices'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
            'type': 'longSum',
            'name': dataSeries.DEVICE_COUNT,
            'fieldName': fieldNames.DEVICE_COUNT
        }]
    }];

var exportedFields = chartTypes.partitionedPointInTimeCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    intervals: config.graphs.GLOBAL.DEVICE_INTERVALS,
    dataKey: dataSeries.DEVICE_COUNT,
    pointsResolution: GRAPHS.GLOBAL.DEVICE_POINTS_RESOLUTION,
    chartTemplate: chartTemplate
});

var totalCustomers = 0;

var insertAt;
for(insertAt = 0; insertAt<exportedFields.tasks.length; insertAt++){
    if(exportedFields.tasks[insertAt].name === 'createDataPointsArray'){
        break;
    }
}

exportedFields.tasks.splice(insertAt, 0, { // insert task before createDataPointsArray
    plugin: function(context, config, next) {
        totalCustomers = context.apiParsedResponseList[0]["customer"].length;
        next();
    }
});

module.exports = exportedFields;

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var xAxisBaseUnit = '',
        yAxisBaseUnit = '',
        xAxisRoundOff = false,
        yAxisRoundOff = true,
        xAxisFormatter = $u.charts.chartXaxisFormatter,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
	yAxisTrimDecimalPlaces = 2;

    data["customerPercentage"] = [];
    data["customerCount"] = [];
    
    var y1Max = 0;
    var y2Max = 0;
     
    _.each(data[dataSeries.DEVICE_COUNT], function(object){
        var newObject = _.cloneDeep(object);
        newObject['y'] = 100 * object['y'] / totalCustomers;
        data["customerPercentage"].push(newObject);
        data["customerCount"].push(object['y']);
        
        if(y1Max < newObject['y']){
            y1Max = newObject['y'];
        }
        if(y2Max < object['y']){
            y2Max = object['y'];
        }
    });
    
    delete data[dataSeries.DEVICE_COUNT];

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            xAxisBaseUnit: xAxisBaseUnit,
            yAxisBaseUnit: yAxisBaseUnit,
            xAxisRoundOff: xAxisRoundOff,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Access Points',
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces
        },
        chart: {
            zoomType: 'xy',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        dataUnit = $u.charts.getUnitsFromMax(yAxisObject.dataMax, '').unit;
                    });

                    _.forEach(chartContext.xAxis, function(xAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        dataUnit = $u.charts.getUnitsFromMax(xAxisObject.dataMax, '').unit;
                        xAxisObject.setTitle({
                            text: data.i18n.XAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var currentContext = this;
                var xTooltipMinUnitObj = xAxisFormatter(currentContext.point.range[0], _.max(currentContext.series.xData), xAxisBaseUnit, xAxisRoundOff, yAxisTrimDecimalPlaces);
                var xTooltipMaxUnitObj = xAxisFormatter(currentContext.point.range[1], _.max(currentContext.series.xData), xAxisBaseUnit, xAxisRoundOff, yAxisTrimDecimalPlaces);
                var yTooltipUnitObj = yAxisFormatter(currentContext.y, _.max(currentContext.series.yData), yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);
                var formatString = xTooltipMinUnitObj.value === xTooltipMaxUnitObj.value ?
                    '{6} of {7} customers ({0} %)<br />  Access Points: <b>{2} {3}</b>' :
                    '{6} of {7} customers ({0} %)<br />  Access Points: <b>{2} {3}</b> to <b>{4} {5}</b>'
                return $u.charts.sformat(
                    formatString,
                    yTooltipUnitObj.value,
                    yTooltipUnitObj.unit,
                    xTooltipMinUnitObj.value,
                    xTooltipMinUnitObj.unit,
                    xTooltipMaxUnitObj.value,
                    xTooltipMaxUnitObj.unit,
                    data.customerCount[this.point.x],
                    totalCustomers
                );
            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        subtitle: {
            text: ''
        },
        plotOptions: {
            area: {
                fillOpacity: 0,
                marker: {
                    radius: width / 400 + 1
                },
                lineWidth: 1.5,
                states: {
                    hover: {
                        lineWidth: 2.5
                    }
                },
                threshold: null
            }
        },
        xAxis: {
            type: 'number',
            title: {
                text: data.i18n.XAXIS_TEXT
            },
            allowDecimals: false,
            labels: {
                step: 1,
                rotation: 0,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                format: '{value}',
                formatter: function() {
                    var that = this,
                        xAxisValue = that.value,
                        xMaxValue = that.axis.dataMax;

                    return xAxisFormatter(xAxisValue, xMaxValue,
                        xAxisBaseUnit, xAxisRoundOff).value;
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            title: {
                text: data.i18n.YAXIS1_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            allowDecimals: false,
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    
                    return Math.ceil(yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value) + '%';
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            endOnTick: false,
            max:y1Max,
            tickLength: 5,
            tickWidth: 1,
            gridLineWidth: 0,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        },{
            title: {
                text: data.i18n.YAXIS2_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            allowDecimals: false,
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;

                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, false).value; // no rounding off
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: 10
            },
            opposite: true,
            min: 0,
            endOnTick: false,
            max:y2Max,
            tickLength: 5,
            tickWidth: 1,
            gridLineWidth: 0,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        series: [{
            showInLegend: false,
            type: 'area',
            yAxis: 0,
            name: '% of Customers',
            data: data["customerPercentage"]
        },
        {
            showInLegend: false,
            type: 'column',
            yAxis: 1,
            visible: false,
            name: 'No. of Customers',
            data: data["customerCount"]
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
